<template>
    <v-dialog max-width="75%" v-model="dialog" persistent>
        <v-card class="pt-2">
            <span class="pa-6 d-flex justify-center headline">
                {{ $t('dialogs-user-edit.texts.welcome') }}
            </span>
            <span class="pa-6 d-flex justify-center body-2">
                {{ $t('dialogs-user-edit.texts.change-password') }}
            </span>

            <user-form
                :model="user"
                :isEdit="false"
                :titlePrefix="$t('users-edit.texts.title-prefix')"
                v-if="user"
                :showBackButton="false"
                :isDialog="true"
            ></user-form>
        </v-card>
    </v-dialog>
</template>

<script>
import UserModel from '@/models/User'
import UserForm from '@/views/users/Form'

export default {
    components: {
        UserForm,
    },

    data() {
        return {
            user: null,
            dialog: false,
        }
    },

    methods: {
        async getUser() {
            let user = await this.model
                .find(this.$store.getters['auth/user'].id)
                .catch(() => {})

            if (!user) {
                this.dialog = false
                return
            }

            this.user = user
        },
    },

    computed: {
        model() {
            return new UserModel()
        },
    },

    async created() {
        await this.getUser()

        this.dialog = true
    },
}
</script>
